import titleOverrides from "./seoTitleOverrides.json";

/** Audit target, not a Google-imposed limit. Display width varies by device. */
export const SEO_TITLE_TARGET = 69;
type TitleLanguage = "en" | "ar";
type TitleOverride = { titleEn?: string; titleAr?: string };
const overrides = titleOverrides as Record<string, TitleOverride>;

export function normalizeSeoTitlePath(path: string): string {
  return path.split(/[?#]/)[0].replace(/\/+$/, "") || "/";
}

/**
 * Keep full H1/article/schema headlines separately. Existing verbose titles use
 * explicit source-backed search labels; unknown titles are never sliced mid-word
 * or silently stripped of a medical qualification merely to satisfy a character count.
 */
export function buildSeoTitle(input: string, path: string, language: TitleLanguage = "en"): string {
  const key = normalizeSeoTitlePath(path);
  const override = Object.prototype.hasOwnProperty.call(overrides, key) ? overrides[key] : undefined;
  const label = (language === "ar" ? override?.titleAr : override?.titleEn) ?? input;
  const core = label.replace(/\s+/g, " ").trim()
    .replace(/\s*[|—–]\s*(?:Bella Rose(?: Medical Center)?(?: Dubai)?|مركز بيلا روز الطبي(?: في دبي)?|بيلا روز(?: دبي)?)(?:\s*[|—–]\s*(?:Bella Rose(?: Medical Center)?(?: Dubai)?|مركز بيلا روز الطبي|بيلا روز))*\s*$/i, "")
    .trim();
  if (/bella rose|بيلا روز/i.test(core)) return core;
  const brand = language === "ar" ? "بيلا روز" : "Bella Rose";
  const branded = `${core} | ${brand}`;
  return Array.from(branded).length <= SEO_TITLE_TARGET ? branded : core;
}
